<div class="recent-calls-list">
  @let showPhoneNumbers = (appConfigService.showPhoneNumbers$ | async) || false;
  @for (item of items; track item.id) {
    <div
      class="recent-call-row"
      (click)="handleSelectCall(item)">
      <app-name-coin [contact]="item.contactId ? (item.contactId | contactById | async) : null"></app-name-coin>

      <div class="call-item-wrapper">
        <app-call-history-item
          class="item-fill"
          [item]="item"
          [showPhoneNumbers]="showPhoneNumbers">
        </app-call-history-item>
      </div>

      <button
        class="call-icon"
        mat-icon-button
        (click)="handleCallNumber(item); $event.stopPropagation()">
        <mat-icon>call</mat-icon>
      </button>
    </div>
  } @empty {
    <div class="empty-state">{{ 'CALLS.NEW_CALL_RECENT_CALLS_EMPTY' | translate }}</div>
  }
</div>
